export const validateCustomField = (field, value, checkValue = true, isBotVariable = false) => {
  const keyRegex = /^[\p{L}\p{N}_\-.]+$/u; // Allows letters, numbers, underscore, hyphen, period.
  const disallowedCharacters = /[\s!@#$%^&*+=~()[\]{}<>\"'\\/|;:]/; // Disallowed characters

  if(!field) throw new Error(`Please add a name for the ${isBotVariable ? 'bot variable' : 'custom field'}!`);
  if(checkValue && !value) throw new Error(`Please add a value for the ${isBotVariable ? 'bot variable' : 'custom field'}!`);

  if(field.length > 60) throw new Error(`${isBotVariable ? 'Bot variable' : 'Custom field'} name cannot exceed 60 characters!`);

  if(disallowedCharacters.test(field)) throw new Error(`${isBotVariable ? 'Bot variable' : 'Custom field'} name cannot contain spaces. Use hyphens (-) or underscores (_) instead.`);

  if(!keyRegex.test(field)) throw new Error(`${isBotVariable ? 'Bot variable' : 'Custom field'} name should only contain alphanumeric characters, hyphens, underscores, or periods.`);

  if(field.toLowerCase() === "sentiment") throw new Error(`You cannot add 'sentiment' as a ${isBotVariable ? 'bot variable' : 'custom field'} name!`);

  if(checkValue && value.length > 240) throw new Error(`${isBotVariable ? 'Bot variable' : 'Custom field'} value cannot exceed 240 characters!`);

  return true;
}

export const validateTag = (tag, customerTags) => {
  if (!tag || !tag.length) return "Please enter a tag first!";

  tag = tag.trim();

  if (tag.length > 120) return "Tag must be 120 characters or fewer.";

  // Allowed characters: Alphanumeric, hyphen (-), underscore (_)
  const validTagRegex = /^[\p{L}\p{N}_-]+$/u;
  
  if (!validTagRegex.test(tag)) {
    return "Invalid tag! Use only letters, numbers, hyphens, or underscores.";
  }

  // Ensure the tag doesn't contain whitespace
  if (/\s/.test(tag)) {
    return "Tags cannot contain spaces. Use hyphens or underscores instead.";
  }

  // Ensure the tag is unique (case-insensitive check)
  const lowerCaseTag = tag.toLowerCase();
  if (customerTags.some(existingTag => existingTag?.tag?.toLowerCase() === lowerCaseTag)) {
    return "This tag already exists!";
  }
  return null; // No errors
}